// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"HX-z","sponsoredTooltipWrapper":"IX-z","sponsoredTooltip":"JX-z","newCard":"KX-z"};